var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","flex-direction":"column","justify-content":"center","align-items":"center","max-width":"400px","margin":"auto"}},[_c('Empty'),_c('p',[_vm._v(_vm._s(_vm.message))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }